import { render, staticRenderFns } from "./configaddorupdate.vue?vue&type=template&id=31928e5a"
import script from "./configaddorupdate.vue?vue&type=script&lang=js"
export * from "./configaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports